<template>
  <!-- toast -->
  <AlertMsg
    :msg="msgObj.msg"
    :show="msgObj.show"
    :role="msgObj.role"
    @closePopup="msgObj.show = false"
  ></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center">
        <h5 class="mb-0 text-primary">
          <i class="fa fa-file-text text-primary"></i> Grades
        </h5>
      </div>
      <hr />
      <label class="form-label">Marks :</label>
      <div class="row g-3">
        <div class="col-md-2">
          <label class="form-label">
            Exam Type<sup><span class="text-danger font-12">*</span></sup> :
          </label>
          <div class="dropdown">
            <button
              class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ examList.find((c) => c._id === Obj.examTypeID)?.Name || "" }}
            </button>
            <ul class="dropdown-menu w-100 scrollable-menu">
              <li
                v-for="(item, index) in examList"
                :key="index"
                :value="item.Name"
              >
                <a
                  class="dropdown-item"
                  href="#"
                  @click.prevent="Obj.examTypeID = item._id"
                >
                  {{ item.Name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-2">
          <label class="form-label">Total Marks :</label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="Obj.totMarks"
          />
        </div>
        <div class="col-md-4">
          <div class="row g-2">
            <div class="col-md-6">
              <label class="form-label"
                >From<sup><span class="text-danger font-12">*</span></sup>
                :</label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="Obj.MarksFrom"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label"
                >To<sup><span class="text-danger font-12">*</span></sup>
                :</label
              >
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="Obj.MarksTo"
              />
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <label class="form-label"
            >Grade<sup><span class="text-danger font-12">*</span></sup> :</label
          >
          <select
            class="form-select form-select-sm rounded cursor-pointer"
            role="button"
            v-model="Obj.Grade"
          >
            <option selected disabled value="">Select grade</option>
            <option v-for="(grade, i) in Grades" :key="i" :value="grade">
              {{ grade }}
            </option>
          </select>
        </div>
        <div class="col-md-2">
          <label class="form-label">Remarks :</label>
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="Obj.Remarks"
          />
        </div>
        <div class="col-md-12 text-end">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button
            type="button"
            class="btn btn-sm btn-soft-dark"
            @click="reset()"
          >
            <i class="fa fa-times-circle me-1"></i> Cancel
          </button>
        </div>
      </div>
    </div>
    <ul v-if="errors.length" class="text-danger ps-3">
      <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
    </ul>
    <div class="col-md-9 table-responsive mt-2" style="margin-top: 5px">
      <div class="progress mb-0 progress-sm" v-if="progress != 0">
        <div
          class="progress-bar"
          role="progressbar"
          :aria-valuenow="progress"
          aria-valuemin="0"
          aria-valuemax="100"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
      <DataTable
        v-if="progress == 0"
        :columns="cols"
        :rows="rows"
        :pageSize="10"
        :actions="{ edit: handleEdit, delete: handleDelete }"
      />
    </div>
  </div>
  <DelPopup
    :name="delObj.Grade"
    @delRecord="delRecord"
    @closeModal="delObj.Grade = ''"
  ></DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from "@/utils/helpers.js";
import { ref, onMounted } from "vue";
import { schoolStore } from "@/utils/schoolStore";
const { examList } = schoolStore();
const Obj = ref({
  totMarks: "",
  MarksFrom: "",
  MarksTo: "",
  Grade: "",
  examTypeID: "",
  Remarks: "",
});
const msgObj = ref({ msg: "", role: "", show: false });
const delObj = ref({});
const errors = ref({});
const Grades = ref(["A", "A+", "B", "B+", "C", "C+", "D","E", "F"]);
const cols = ref([
  { label: "S.No", key: "Sno" },
  { label: "Exam Type", key: "examName" },
  { label: "Total Marks", key: "totMarks" },
  { label: "Marks From", key: "MarksFrom" },
  { label: "Marks To", key: "MarksTo" },
  { label: "Grade", key: "Grade" },
  { label: "Remarks", key: "Remarks" },
]);
const handleEdit = (row) => {
  Obj.value = { ...row };
};
const handleDelete = (row) => {
  delObj.value = { ...row };
};
const rows = ref([]);
const save = async () => {
  const fields = {
    From: { value: Obj.value.MarksFrom, validators: [isRequired] },
    To: { value: Obj.value.MarksTo, validators: [isRequired] },
    Grade: { value: Obj.value.Grade, validators: [isRequired] },
  };
  const MarkFrom = Number(Obj.value.MarksFrom);
  const MarkTo = Number(Obj.value.MarksTo);
  if (isNaN(MarkFrom) || isNaN(MarkTo) || MarkFrom > MarkTo) {
    msgObj.value = {
      msg: "Please enter a valid marks range.",
      role: "danger",
      show: true,
    };
    return;
  }
  const idx1 = rows.value.some((item) => {
    const from = Number(item.MarksFrom);
    const to = Number(item.MarksTo);
    return (
      item._id == Obj.value._id &&
      Obj.value.Grade.toLowerCase() == item.Grade.toLowerCase() &&
      Obj.value.totMarks == item.totMarks &&
      MarkTo == from &&
      MarkFrom == to
    );
  });
  if (idx1) {
    msgObj.value = { msg: "Marks already exists", role: "danger", show: true };
    return;
  }
  const idx = rows.value.findIndex(
    (item) =>
      item.Grade.toLowerCase() === Obj.value.Grade.toLowerCase() &&
      Obj.value.totMarks == item.totMarks &&
      MarkTo == Number(item.MarksFrom) &&
      MarkFrom == Number(item.MarksTo) &&
      item._id == Obj.value._id,
  );
  if (idx >= 0) {
    msgObj.value = {
      msg: "Grade Type already exists.",
      role: "danger",
      show: true,
    };
    return;
  }
  errors.value = validateForm(fields);
  if (Object.keys(errors.value).length === 0) {
    const { url, method, msg } = curdStatus(Obj.value);
    await api[method](`/Grade${url}`, Obj.value)
      .then((response) => {
        loadData();
        reset();
        msgObj.value = {
          msg: `Grade ${msg} Successfully`,
          role: "success",
          show: true,
        };
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
const reset = async () => {
  Obj.value = { MarksFrom: "", MarksTo: "", Grade: "" };
  errors.value = {};
};
const progress = ref(0);
const loadData = async () => {
  let direction = 1;
  let progressInterval = setInterval(() => {
    progress.value += direction;
    if (progress.value >= 100) {
      progress.value = 0;
    }
  }, 100);
  await api.get("/Grade/all").then((response) => {
    rows.value = response.data.map((item, i) => ({
      ...item,
      Sno: i + 1,
      examName:
        examList.value.find((c) => c._id === item.examTypeID)?.Name || "",
    }));
    progress.value = 0;
    clearInterval(progressInterval);
  });
};
const delRecord = async () => {
  await api.delete(`/Grade/${delObj.value._id}`).then(() => {
    loadData();
    delObj.value = {};
    msgObj.value = {
      msg: "Grade Deleted Successfuly.",
      role: "danger",
      show: true,
    };
  });
};
onMounted(() => {
  loadData();
});
</script>
